import { render, staticRenderFns } from "./WebQuestionList.vue?vue&type=template&id=48b4bf66&"
import script from "./WebQuestionList.vue?vue&type=script&lang=js&"
export * from "./WebQuestionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports